
import {
    GET_ALL_DOCTORS
   } from "../../constant/ActionType";
   
   export default function GetAllDoctors(state = {
       AllDoctorsData: [],
   
   }, action) {
       switch (action.type) {
           case GET_ALL_DOCTORS:
               return {
                   ...state,
                   AllDoctorsData: action?.data?.data,
               };
   
           default:
       }
   
       return state;
   }